import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Deal, ProductTag } from '@vestiaire/api-sdk-angular';

@Component({
  selector: 'vc-product-tags',
  templateUrl: './product-tags.component.html',
  styleUrls: ['./product-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductTagsComponent {
  @Input()
  tags: Array<ProductTag>;

  @Input()
  isDealsActive: boolean;

  @Input()
  currentDeal: Deal;
}
